<ng-container *ngIf="!isCardViewVisible">
  <div class="mb-checkout-billing-address" data-cy="mb-checkout-billing-address">
    <form [formGroup]="billingForm">
      <div class="row mb-3">
        <div class="col-sm-12 col-md-9 text-left mb-checkout-headline"
             data-cy="mb-billing-header">
          <div *ngIf="isPurchaseCheckoutType">{{ 'address.purchaseBillingAddressFormHeadline' | cxTranslate }}</div>
          <div *ngIf="!isPurchaseCheckoutType">{{ 'address.requestBillingAddressHeadline1' | cxTranslate }}</div>
        </div>
        <div class="col-sm-12 col-md-3 mt-3 mt-md-0 mb-1 text-md-right mb-checkout-mandatory-text"
             data-cy="mb-form-billing-info-mandatory-text">{{ 'mbcommon.mandatory' | cxTranslate }}</div>
      </div>
      <div *ngIf="!isPurchaseCheckoutType" class="col-12 pl-md-0 mb-checkout-sub-headline mb-4">{{ 'address.requestBillingAddressHeadline2' | cxTranslate }}</div>

      <div class="row mb-4">
        <div class="col-12 ml-3 pl-0" data-cy="mb-billing-prefill">
          <span class="mb-billing-prefill-label" (click)="prefillActivate()">
            {{ 'address.prefillText' | cxTranslate }}
          </span>
        </div>
      </div>

      <mb-checkout-base-form-partial [address]="billingAddress"
                                     [formGroup]="billingForm"
                                     [companyLabelKey]="'address.companyUniversity'"
                                     [instituteLabelKey]="'address.institute'"
                                     [departmentLabelKey]="'address.departmentDivision'"
                                     [buildingLabelKey]="'address.buildingFloorRoom'"
                                     [labLabelKey]="'address.labGroupPI'">
      </mb-checkout-base-form-partial>

      <mb-checkout-location-form-partial [address]="billingAddress"
                                         [formGroup]="billingForm"
                                         [streetInformationLabelKey]="'address.street'">
      </mb-checkout-location-form-partial>

      <mb-checkout-zip-code-form-partial [address]="billingAddress"
                                         [formGroup]="billingForm"
                                         [zipCodeLabelKey]="'address.zipCode'">
      </mb-checkout-zip-code-form-partial>

      <mb-checkout-city-form-partial [address]="billingAddress"
                                     [formGroup]="billingForm"
                                     [cityLabelKey]="'address.city'">
      </mb-checkout-city-form-partial>

      <mb-checkout-country-form-partial [address]="billingAddress"
                                        [formGroup]="billingForm"
                                        [isCountryDisabled]="isCountryDisabled()">
      </mb-checkout-country-form-partial>

      <mb-checkout-vat-id-form-partial [address]="billingAddress"
                                       [formGroup]="billingForm">
      </mb-checkout-vat-id-form-partial>

      <div class="row no-gutters mt-4">
        <div class="col-12 col-lg mr-4 mt-2 order-2 order-lg-1">
          <button data-cy="mb-checkout-billing-back-btn"
                  class="btn btn-block btn-secondary mb-buttons"
                  type="button"
                  (click)="cancel()">
            {{ (!displaySimpleButtons ? 'navigationPage.backBtn' : 'navigationPage.cancelBtn') | cxTranslate }}
          </button>
        </div>
        <div class="col-12 col-lg mt-2 order-1 order-lg-2">
          <button
            data-cy="mb-checkout-billing-next-btn"
            class="btn btn-block btn-primary mb-buttons"
            type="button"
            mbOneClickAllowed
            (click)="saveAndContinue()">
            {{ (!displaySimpleButtons ? 'navigationPage.nextBtn' : 'navigationPage.saveAndContinueBtn') | cxTranslate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</ng-container>
